/**
 * 后端 alert.Input / demand.Input / response.Input 里的时间字段都是 Go time.Time，
 * JSON 反序列化走 time.Parse(time.RFC3339, ...)，喂 "2026-10-08 09:00:00" 会直接 422。
 * el-date-picker 默认给的就是这种空格格式，所以提交前统一在 api 层转一道。
 */

/** el-date-picker 的 `YYYY-MM-DD HH:mm:ss` → RFC3339（UTC，带 Z）。 */
export function toRFC3339(value: string | null | undefined): string | undefined {
  const v = (value ?? '').trim()
  if (!v) return undefined
  // 不带时区偏移的 datetime 形式按 ES 规范按本地时间解析，所以选哪个钟点就转成哪个钟点
  const d = new Date(v.replace(' ', 'T'))
  if (Number.isNaN(d.getTime())) return undefined
  return d.toISOString()
}

/** RFC3339 → el-date-picker 的 `YYYY-MM-DD HH:mm:ss`（本地时区，秒位补 0）。 */
export function toPickerValue(value: string | null | undefined): string | null {
  const v = (value ?? '').trim()
  if (!v) return null
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return null
  const p = (n: number): string => String(n).padStart(2, '0')
  return (
    `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}` +
    ` ${p(d.getHours())}:${p(d.getMinutes())}:00`
  )
}
